// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "patientDashboard." + ({"138":"profile","147":"app-routes","251":"checkout","352":"onboarding"}[chunkId] || chunkId) + "." + {"138":"520edf8cb35bee44a9d1","147":"a8d889ca1d0d4644551d","251":"aae731a036654472d921","352":"a09fc1effea6112ec2a3","631":"7f6481807ea5020ff807"}[chunkId] + ".js";
};